<template>
    <h1 class="">RFID Piece Up LOGS</h1>
    <div id="page-rfid-pieceup" class="content-section">
        <div class="page-section">
             <div class="content-section">
            <div class="row">
            <div class="col-md-3">
                <div >
                <FormKit
                    type="button"
                    label="Go Back"
                    input-class="$reset btn-rfid-sm btn btn-rfid btn-associate btn-goback"
                    @click="goTo('Dashboard')"
                    prefix-icon="arrowLeft"
                    prefix-icon-class="btn-rfid-back"
                />
                </div>
            </div>

            
            </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import {onMounted, ref, watch, inject, reactive, nextTick} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css';
import ServiceTicket from '@/services/ServiceTicketService.js';
import { barcodePatterns } from '@/utils/orderUtils';

const goTo = (pageSection, item=false) =>   {
  switch (pageSection) {
    case "Dashboard":
      window.open(
          "/rfid/dashboard",
          "_self"
      );
      break;
    case "NewGarment":
      window.open(
          "/garmenttype",
          "_blank"
      );
      break;
    case "RefreshGarment":
      refreshgarment();
      break;
  }
}

</script>


<style scoped>

.main-section > h1:first-child {
  background: var(--pieceup-bg-color);
}
.error-message {
  color: var(--red-color);
  font-weight: bold;
}
.highlight-row {
  background-color: #ffeeba !important; /* or any highlight color */
  transition: background-color 0.5s;
}
</style>
